<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">
                    <b-form @submit.prevent="load" @keyup.enter="load()">
                        <b-form-row class="d-flex flex-wrap">
                            <lg-form-input v-model="form.processo" label="Processo:" cols="3" />
                            <lg-form-input v-model="form.solicitante" label="Solicitante:" cols="3" />
                            <lg-form-input v-model="form.de" label="De:" type="date" cols="3" />
                            <lg-form-input v-model="form.ate" label="Até:" type="date" cols="3" />
                        </b-form-row>
                        <b-form-row class="d-flex flex-wrap">
                            <LgFinderPageUnidadeAdministrativa id="finderDepartamentoIBP" v-model="departamento"
                                @onselect="departamentoSelect"> </LgFinderPageUnidadeAdministrativa>
                            <lg-form-input v-model="form.produto.descricao" label="Produto:" disabled cols="3"
                                class="flex-fill" />
                            <lg-form-const-select label="Situação:" @change='load' cols="3" v-model="form.codStatus"
                                :options="optionsFilterSituacao" class="flex-fill" />
                            <b-col cols="12" class="text-right">
                                <b-button class="ml-3 mr-2 my-2" size="sm" pill variant="primary" @click="load">
                                    <b-icon icon="search" />
                                </b-button>
                                <b-button class="ml-3 mr-2 my-2" size="sm" pill variant="primary" @click="limparForm">
                                    <b-icon icon="eraser" />
                                </b-button>
                            </b-col>
                        </b-form-row>
                    </b-form>
                </b-card>
                <b-card bg-variant="light">
                    <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="tableFields"
                        :hover="true" show-empty @row-selected="onRowSelected" td-class="p-2">
                        <template #empty>
                            <p>Nenhum registro encontrado</p>
                        </template>
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                            </div>
                        </template>
                        <template v-slot:head(selecionar)>
                            <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(selecionar)="{ item }">
                            <b-form-checkbox v-if="!item.processo" v-model="selectedItems"
                                :value="item"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(data)="{ item }">
                            {{ formatDate(item.data) }}
                        </template>
                        <template v-slot:cell(valor)="{ item }">
                            {{ formatCurrency(item.valor) }}
                        </template>
                        <template v-slot:cell(total)="{ item }">
                            {{ formatCurrency(item.total) }}
                        </template>
                    </b-table>
                    <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page
                                }} de {{
                                totalPage }} -
                                {{ total }} registros</b-col>
                            <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                <b-form-select size="sm" v-model="perPage" @change="load"
                                    :options="perPageOptions"></b-form-select>
                            </b-col>
                        </b-col>
                        <b-col cols="6">
                            <div class="d-flex justify-content-end align-items-end">
                                <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                    :per-page="perPage" :total-rows="total"></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col class="d-flex justify-content-center">
                            <b-button @click="validateAndShowModal" variant="primary" class="mr-2 rounded-pill"
                                v-b-tooltip.hover title="Gerar processos de compra">
                                <b-icon icon="play-fill"></b-icon>
                            </b-button>
                            <b-button @click="cancelar" class='rounded-pill' variant="danger" v-b-tooltip.hover
                                title="Cancelar">
                                <b-icon icon="x-circle"></b-icon>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card>
            </b-card-body>
        </b-card>

        <b-modal hide-footer id="modal-gerar-processo" ref="modal" title="Gerar Processo de Compra">
            <b-form @submit.prevent="verificarProcesso">
                <b-form-group label="Digite o número do processo de compra" label-for="nome-processo">
                    <b-form-input id="nome-processo" v-model="nomeProcesso" required></b-form-input>
                </b-form-group>
                <div class="d-flex justify-content-center">
                    <b-button type="submit" variant="primary" class="mr-2 rounded-pill">
                        <b-icon icon="check"></b-icon>
                    </b-button>
                    <b-button @click="hideModal" class='rounded-pill' variant="danger">
                        <b-icon icon="x-circle"></b-icon>
                    </b-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from '@/components/Finders/LgFinderPageUnidadeAdministrativa.vue'
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import moment from 'moment'
import API from '../../../core/api'

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
        LgFinderPageUnidadeAdministrativa
    },
    props: {
        prefix: {
            type: Array,
            default: () => []
        },
        produto: {
            type: Object,
            default: () => { },
            required: true
        },
    },
    data() {
        return {
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: {},
            departamento: null,
            form: {
                processo: null,
                solicitante: null,
                de: null,
                ate: null,
                codDepartamento: null,
                produto: null,
                codStatus: 222,
            },
            optionsFilterSituacao: [
                { key: "filterSituacao", text: "Aguardando", value: 223 },
                { key: "filterSituacao", text: "Em análise", value: 222 },
                { key: "filterSituacao", text: "Finalizado", value: 224 },
            ],
            busy: false,
            records: [],
            page: 1,
            total: 0,
            totalPage: 0,
            selectedItems: [],
            selectAll: false,
            nomeProcesso: '',
        }
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.form.produto = this.produto
        this.$service = new ResourceService(`/api/pedidosprodutocatalogo/itens`)
    },
    mounted() {
        this.load()
    },
    watch: {
        page() {
            this.load()
        },
        selectAll(newVal) {
            this.toggleSelectAll(newVal)
        }
    },
    computed: {
        tableFields() {
            return [
                { key: "selecionar", label: "", tdClass: "w-1 align-items-center" },
                { key: "processo", label: "Processo", tdClass: "p-2" },
                { key: "pedido", label: "Pedido", tdClass: "p-2" },
                { key: "data", label: "Data", tdClass: "p-2" },
                { key: "solicitante", label: "Solicitante", tdClass: "p-2" },
                { key: "numeroProduto", label: "Número Produto", tdClass: "p-2" },
                { key: "descricao", label: "Descrição", tdClass: "p-2" },
                { key: "quantidade", label: "Quant.", tdClass: "p-2" },
                { key: "valor", label: "Valor", tdClass: "p-2" },
                { key: "total", label: "Total", tdClass: "p-2" },
            ]
        },
    },
    created() {
        const brand = JSON.parse(localStorage.getItem("context"))
        this.departamento = brand.departamento
        this.form.codDepartamento = brand.departamento.id
    },
    methods: {
        departamentoSelect(item) {
            this.form.codDepartamento = item.id
            this.load()
        },
        async load() {
            this.busy = true
            const formCopy = { ...this.form, produtoId: this.form.produto.id }
            this.$loadResource({
                limit: this.perPage,
                page: this.page,
                params: formCopy,
                isOrOperation: false,
            })
        },
        cancelar() {
            this.$emit('close')
        },
        limparForm() {
            this.form = {
                processo: "",
                solicitante: "",
                de: "",
                ate: "",
                departamento: "",
                produto: "",
                situacao: "1",
            }
            this.load()
        },
        selecionarItem(item) {
            this.$emit("onSelectItem", { ...item, prefix: this.prefix, codEmpresa: this.codEmpresa })
        },
        toggleSelectAll(newVal) {
            if (newVal) {
                this.selectedItems = this.records.filter(item => !item.processo)
            } else {
                this.selectedItems = []
            }
        },
        onRowSelected(items) {
            this.selectedItems = items
        },
        validateAndShowModal() {
            if (this.selectedItems.length === 0) {
                this.$bvToast.toast('Marque os pedidos antes de iniciar o processo de compra.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
            } else {
                this.showModal()
            }
        },
        showModal() {
            this.$refs.modal.show()
        },
        hideModal() {
            this.$refs.modal.hide()
        },

        async verificarProcesso() {
            try {
                const response = await API.get(`/api/pedidosprodutocatalogo/verificar-processo/${this.nomeProcesso}`)
                if (response.data.existe) {
                    this.$bvModal.msgBoxConfirm('Esse número de processo já existe, deseja adicionar os itens selecionados ao processo existente?', {
                        title: 'Confirmação',
                        size: 'md',
                        buttonSize: 'md',
                        okVariant: 'success',
                        okTitle: 'Sim',
                        cancelTitle: 'Não',
                        cancelVariant: 'danger',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    }).then(value => {
                        if (value) {
                            this.gerarProcesso()
                        }
                    }).catch(err => {
                        console.error(err)
                    })
                } else {
                    this.gerarProcesso()
                }
            } catch (error) {
                this.$bvToast.toast(error.response.data, {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
            }
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss')
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
        },
        async gerarProcesso() {
            const itemIds = this.selectedItems.map(item => item.id)
            try {
                await API.put(`/api/pedidosprodutocatalogo/itens/vincular-processo/${this.nomeProcesso}`, {
                    itemIds: itemIds
                })
                this.load()
                this.hideModal()
                this.$bvToast.toast('Processo de compra gerado com sucesso!', {
                    title: 'Sucesso',
                    variant: 'success',
                    solid: true
                })
                this.$emit('processCreated')
            } catch (error) {
                this.$bvToast.toast(error.response.data, {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
            }
        }
    },
}
</script>
